import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ErrorBoundaryHolder from '../styles/errorBoundaryStyle';
import { Row, Col, Button } from 'antd';
import imageRobot from '../../../images/not-found-img3.png';
import logoWhite from '../../../images/logo-latinad-white.png';
import Api from '../../../services/Api';
import { toErrorJson } from '../../../services/utils';

const CriticalErrorFallbackComponent = ({ error = null }) => {
  const { t } = useTranslation();
  const [errorSaved, setErrorSaved] = useState(false);

  const handleGoBackAndReload = () => {
    if (window.history.length > 1) {
      window.history.back();
      setTimeout(() => {
        window.location.reload();
      }, 100);
    } else {
      window.location.href = '/';
    }
  };

  const handleClearCache = async () => {
    try {
      // Clear Cache Storage
      if ('caches' in window) {
        const cacheNames = await caches.keys();
        await Promise.all(cacheNames.map(name => caches.delete(name)));
      }
      // Clear Local Storage
      localStorage.clear();
    } finally {
      // Redirect to root to ensure a clean state
      window.location.href = '/';
    }
  };

  useEffect(() => {
    if (error && !errorSaved) {
      const payload = {
        ...toErrorJson(error),
        url: window.location.href,
        userAgent: navigator.userAgent
      };

      Api.create()
        .saveErrors(payload)
        .finally(() => {
          setErrorSaved(true);
        });
    }
  }, [error, errorSaved]);

  return (
    <ErrorBoundaryHolder>
      <div className="error-container">
        <Row>
          <Col xs={{ span: 24, order: 2 }} sm={{ span: 10, order: 1 }} md={10} lg={10} xl={11}>
            <div className="leftSideContainer">
              <img src={logoWhite} className="logLatinadWhite" alt="" />
              <h1>{t('An unexpected error has occurred')}</h1>
              <p>
                {t(
                  'To continue browsing, please press the button to return to the previous page. We are working to improve your experience on our platform. Thank you for your understanding!'
                )}
              </p>
              <div className="btns-container">
                <Button onClick={handleClearCache} className="btn-error-fallback base-btn">
                  {t('Clear caché')}
                </Button>
                <Button onClick={handleGoBackAndReload} className="go-back-btn base-btn">
                  {t('Resume browsing')}
                </Button>
              </div>
            </div>
          </Col>
          <Col xs={{ span: 24, order: 1 }} sm={{ span: 14, order: 2 }} md={14} lg={14} xl={13}>
            <img src={imageRobot} className="imageBg" alt="" />
          </Col>
        </Row>
      </div>
    </ErrorBoundaryHolder>
  );
};

export default CriticalErrorFallbackComponent;
